import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/landPage/classPurchase/like.png'
import _imports_1 from '@/assets/landPage/classPurchase/price.png'


const _withScopeId = n => (_pushScopeId("data-v-af4abaa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "classChurase" }
const _hoisted_2 = { class: "classChurase-poster-img" }
const _hoisted_3 = {
  key: 0,
  class: "class-time flex-xy-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "class-time-colon" }, "距结束：", -1))
const _hoisted_5 = { class: "class-time-block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "class-time-colon" }, "天", -1))
const _hoisted_7 = { class: "class-time-block" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "class-time-colon" }, "时", -1))
const _hoisted_9 = { class: "class-time-block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "class-time-colon" }, "分", -1))
const _hoisted_11 = { class: "class-time-block" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "class-time-colon" }, "秒", -1))
const _hoisted_13 = { class: "class-wrap" }
const _hoisted_14 = { class: "classPurchase-info" }
const _hoisted_15 = { class: "flex classPurchase-info-wrap" }
const _hoisted_16 = { class: "flex-grow-0" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "flex flex-col classPurchase-info-content flex-grow-1" }
const _hoisted_19 = { class: "classPurchase-info-title text-more-double" }
const _hoisted_20 = {
  key: 0,
  class: "classPurchase-info-recommend flex-y-center"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "classPurchase-info-like",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 推荐 ")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "classPurchase-info-title1" }
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { class: "flex-grow-1 flex-y-center classPurchase-info-price" }
const _hoisted_27 = {
  href: "javascript:;",
  name: "领取课程",
  class: "flex-grow-0"
}
const _hoisted_28 = { class: "flex-grow-0 flex-y-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "classPurchase-info-bg" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_LoginModel = _resolveComponent("LoginModel")!
  const _component_gainShowModel = _resolveComponent("gainShowModel")!
  const _component_wxModelShowModel = _resolveComponent("wxModelShowModel")!
  const _component_noDataModel = _resolveComponent("noDataModel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        src: _ctx.activityInfo.indexImg,
        fit: "cover"
      }, null, 8, ["src"])
    ]),
    (_ctx.courseList.length>0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "class-area",
          style: _normalizeStyle(_ctx.activityInfo.indexStyle)
        }, [
          (_ctx.activityInfo.styleType==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_CountDown, { time: _ctx.activityTime }, {
                  default: _withCtx((timeData) => [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, _toDisplayString(timeData.days), 1),
                    _hoisted_6,
                    _createElementVNode("span", _hoisted_7, _toDisplayString(timeData.hours), 1),
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(timeData.minutes), 1),
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, _toDisplayString(timeData.seconds), 1),
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["time"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (list, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "class-list",
                key: index
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        class: "classPurchase-info-img",
                        src: list.coverImg,
                        alt: ""
                      }, null, 8, _hoisted_17)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (list.isRecommend)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_23))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(list.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, " ¥" + _toDisplayString(list.underlinedPrice), 1),
                        _createElementVNode("a", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("img", {
                              onClick: ($event: any) => (_ctx.handleGainClass(list)),
                              class: "classPurchase-info-btn",
                              src: _imports_1,
                              alt: ""
                            }, null, 8, _hoisted_29)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_30
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "class-list-bottom flex-xy-center",
            style: _normalizeStyle(_ctx.activityInfo.bottomTitleStyle)
          }, _toDisplayString(_ctx.activityInfo.bottomTitle), 5)
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_LoginModel, {
      showModel: _ctx.showLogin,
      onHandleCloseShow: _ctx.handleCloseShow
    }, null, 8, ["showModel", "onHandleCloseShow"]),
    _createVNode(_component_gainShowModel),
    _createVNode(_component_wxModelShowModel),
    (_ctx.courseList.length==0)
      ? (_openBlock(), _createBlock(_component_noDataModel, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}